export const appConfig = {
  id: "portfolio",
  name: "Portfolio",
  description: "Portfolio application",
  repository: {
    owner: "",
    name: "",
  },
} as const;

export type AppConfig = typeof appConfig;
